import Vue from 'vue'
import { StripeElementPayment, StripePlugin, StripeCheckout } from '@vue-stripe/vue-stripe'

export default () => {
  Vue.component('StripeElementPayment', StripeElementPayment)
  Vue.component('StripePlugin', StripePlugin)
  Vue.component('StripeCheckout', StripeCheckout)
}
